import pRetry from "@-/com.npmjs.p-retry";

/** Only files created by this open are disposable bootstrap state. */
export async function retryTursoBootstrap<T>(options: {
  hadPersistedDatabase: boolean;
  /** An error another attempt cannot change; it is thrown at once. */
  isFinal?(error: unknown): boolean;
  maxAttempts: number;
  open(): Promise<T>;
  prepareAttempt?(): Promise<void>;
  resetBootstrap(): Promise<unknown>;
}): Promise<T> {
  return pRetry(
    async (attempt) => {
      await options.prepareAttempt?.();
      if (attempt > 1 && !options.hadPersistedDatabase) {
        await options.resetBootstrap();
      }
      return options.open();
    },
    {
      retries: options.maxAttempts - 1,
      shouldRetry: ({ error }) => options.isFinal?.(error) !== true,
    },
  );
}
